import { render, staticRenderFns } from "./PrintLabelsModal.vue?vue&type=template&id=947155b4&scoped=true"
import script from "./PrintLabelsModal.vue?vue&type=script&lang=ts"
export * from "./PrintLabelsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947155b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('947155b4')) {
      api.createRecord('947155b4', component.options)
    } else {
      api.reload('947155b4', component.options)
    }
    module.hot.accept("./PrintLabelsModal.vue?vue&type=template&id=947155b4&scoped=true", function () {
      api.rerender('947155b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/PrintLabelsModal.vue"
export default component.exports